import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLazyGetApiProjectsQuery } from '../../../../../app/athenaApiGen';
import CustomNoRows from '../../../../../components/DataGrid/CustomNoRows';
import { StyledDataGrid } from '../../../../../shared-theme/StyledComponents';

const Projects = () => {
  const [params, setParams] = useState({
    page: 0,
    pageSize: 4,
  });
  const [queryProjects, { data, isLoading }] = useLazyGetApiProjectsQuery();
  const rowCountRef = useRef(data?.total || 0);

  // Get user actions and login status for ACL
  const { actions, loggedIn } = useSelector((state) => state.user);

  // Check if user has list-projects permission (following Deliverables pattern)
  // The backend will auto-filter results based on JWT claims
  const canListProjects = useMemo(() => {
    if (!actions || actions.length === 0) return false;
    return actions.some((action) => action?.action === 'list-projects');
  }, [actions]);

  const rowCount = useMemo(() => {
    if (data?.total !== undefined) {
      rowCountRef.current = data.total;
    }
    return rowCountRef.current;
  }, [data?.total]);

  const fetchProjects = useCallback(async () => {
    // Don't fetch if not logged in or no permission
    if (!loggedIn || !canListProjects) return;

    try {
      // Following Deliverables pattern: DON'T pass programId
      // Backend auto-filters based on JWT claims
      await queryProjects({
        page: params.page + 1,
        pageSize: params.pageSize,
      }).unwrap();
    } catch (err) {
      console.log(err);
    }
  }, [params, queryProjects, loggedIn, canListProjects]);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  return (
    <StyledDataGrid
      paginationMode="server"
      loading={isLoading}
      paginationModel={params}
      onPaginationModelChange={setParams}
      rowCount={rowCount}
      pageSizeOptions={[4, 6]}
      rows={canListProjects ? (data?.projects ?? []) : []}
      getRowId={(proj) => proj.projectId}
      columns={[
        {
          field: 'title',
          headerName: 'Project Name',
          minWidth: 100,
        },
        {
          field: 'description',
          headerName: 'Description',
          flex: 1,
        },
        {
          field: 'projectCode',
          headerName: 'Code',
          minWidth: 100,
        },
      ]}
      slots={{
        noRowsOverlay: CustomNoRows,
      }}
    />
  );
};

export default Projects;
